import React from 'react'
import { connect } from 'react-redux'
import NoEvent from '../components/Router/Event/NoEvent'
import OneEvent from '../components/Router/Event/OneEvent'
import Router from '../components/Router/Router'
import { Event } from '../model/Event'
import { IStore } from '../model/IStore'

const RouterContainer = ({ events }: { events: Event[] }) => {
  if (events.length === 0) {
    return (
      <NoEvent/>
    )
  }

  if (events.length === 1) {
    return (
      <OneEvent event={events[0]}/>
    )
  }

  return (
    <Router events={events}/>
  )
}

const mapStateToProps = (state: IStore) => ({ events: state.events })

export default connect(mapStateToProps)(RouterContainer)
